// Wiring for main.ts (gates A1.4, A1.5): the fault switches and the content (loaded first, so boot screens can use the
// strings). The one kernel game is built by the sim host (src/sim/host.ts, `createCore` with the scene's modules).
import { loadSpikeContent, plantRawString, type SpikeContent } from "../content";
import { CONTENT_FAULTS } from "../content/checks";
import { CORE_FAULTS } from "./index";

/** The fault names this module owns, for the spike's one `?faults=` switch. */
export const CORE_FAULT_NAMES = ["throwing-system", "no-isolation", "broken-ref", "raw-string"] as const;

/** Turn on the planted defects `?faults=a,b` names (this stream's: throwing-system, no-isolation, broken-ref, raw-string). */
export function applyFaultSwitches(search = location.search): string[] {
  const on = (new URLSearchParams(search).get("faults") ?? "").split(",").filter(Boolean);
  CORE_FAULTS.throwingSystem = on.includes("throwing-system");
  CORE_FAULTS.noIsolation = on.includes("no-isolation");
  CONTENT_FAULTS.brokenRef = on.includes("broken-ref");
  CONTENT_FAULTS.rawString = on.includes("raw-string");
  return on;
}

/** Load the content (and plant the raw string when switched on). Call after the error capture is installed. */
export function setupContent(): { content: SpikeContent; handle: { content: { report: SpikeContent["report"]; t: SpikeContent["t"]; scanRawStrings: () => string[] } } } {
  applyFaultSwitches();
  const content = loadSpikeContent();
  if (CONTENT_FAULTS.rawString) plantRawString();
  return { content, handle: { content: { report: content.report, t: content.t, scanRawStrings: () => content.scanRawStrings() } } };
}
